__turbopack_context__.v({
  "button": "link-module-scss-module__lwKDDq__button",
  "link": "link-module-scss-module__lwKDDq__link",
  "secondary": "link-module-scss-module__lwKDDq__secondary",
});
